import '@/design/tokens.css';

import { startApplication } from '@/app/bootstrap';

/**
 * The entry point, and deliberately nothing more than one call.
 *
 * Everything that could be got wrong — fetching the configuration before the first render, applying
 * the theme before the first paint, restoring a session without flashing the sign-in form — lives in
 * `app/bootstrap.tsx`, where a test can drive it with its own `fetch` and its own container. A
 * module that did that work here would be the one part of the application nothing could exercise.
 */
const container = document.querySelector('#root');
if (container === null) {
  throw new Error('index.html has no #root element to mount into');
}

await startApplication({ container: container as HTMLElement });
